module.exports = __webpack_public_path__ + "media/images/client-12-9e51496d77091eee1f8f6c02166da56b.png";